function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useAppCreateReferralContext } from "./AppCreateReferralProvider";
export default function withAppCreateReferralContext(ComposedComponent) {
  return function (props) {
    var _useAppCreateReferral = useAppCreateReferralContext(),
      dispatch = _useAppCreateReferral.dispatch;
    return /*#__PURE__*/React.createElement(ComposedComponent, _extends({}, props, {
      dispatchCreateReferral: dispatch
    }));
  };
}
//# sourceMappingURL=withAppCreateReferralContext.js.map